module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasServices) ? _c('div', {
    staticClass: "tracking-types"
  }, _vm._l((_vm.services), function(service, i) {
    return _c('span', {
      key: ("service-" + i),
      staticClass: "service",
      class: {
        'active': _vm.activeService === service.service
      },
      on: {
        "click": function($event) {
          return _vm.handleService(service.service)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (_vm.getService(service.service).tooltip),
        expression: "getService(service.service).tooltip"
      }],
      attrs: {
        "src": _vm.getService(service.service).logo
      },
      on: {
        "click": function($event) {
          return _vm.handleService(service.service)
        }
      }
    })])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a335fb9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/ServiceTrackingTypes/ServiceTrackingTypes.vue
// module id = 3125
// module chunks = 1